import { DateTimeFormatOptions } from "../../Models/Classes";
import { GetDateTimeFormatOptions } from "./GetDateTimeFormatOptions";

export const FormatDateTimeFromDate = (datetime: Date | undefined | null, options: DateTimeFormatOptions = {}): string => {
    if (!datetime) return "";
    const formatOptions = GetDateTimeFormatOptions(options);
    return new Intl.DateTimeFormat('it-IT', formatOptions).format(datetime);
}